// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QD17","rootNoMargin":"styles_rootNoMargin__KKSno"};